var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnapActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1021_36934)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91439 8.00927L7.02402 4.89963L11.6724 9.54798L8.56273 12.6576C7.23498 13.9854 7.23498 16.1381 8.56273 17.4658C9.89048 18.7936 12.0432 18.7936 13.3709 17.4658L16.4806 14.3562L21.1289 19.0045L18.0193 22.1142C14.1243 26.0091 7.80935 26.0091 3.91438 22.1142C0.0194197 18.2192 0.0194271 11.9042 3.91439 8.00927Z",
    fill: "#356733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6784 1.21722C11.0153 0.880394 11.5614 0.880394 11.8982 1.21722L15.3651 4.68413C15.7019 5.02095 15.7019 5.56705 15.3651 5.90388L12.9285 8.34046L8.85172 4.26367C8.5149 3.92685 8.5149 3.38075 8.85172 3.04393L10.6784 1.21722Z",
    fill: "#356733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1091 10.6479C20.4459 10.3111 20.992 10.3111 21.3289 10.6479L24.7543 14.0734C25.0912 14.4102 25.0912 14.9563 24.7543 15.2931L22.3178 17.7297L17.6725 13.0845L20.1091 10.6479Z",
    fill: "#356733"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1021_36934",
    x: 0.993164,
    y: 0.9646,
    width: 25.0137,
    height: 25.0708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_36934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_36934",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapActive);
export default __webpack_public_path__ + "static/media/snap-active.ef478859b8334c01727f7f88656b3c2e.svg";
export { ForwardRef as ReactComponent };